const getters = {
  token: state => state.user.token,
  Id: state => state.user.Id,
  AgencyName: state => state.user.AgencyName,
  AgencyArea: state => state.user.AgencyArea,
  ShareRatio: state => state.user.ShareRatio,
  CommissionRatio: state => state.user.CommissionRatio,
  AgencyBalance: state => (state.user.AgencyBalance ? Number(parseFloat(state.user.AgencyBalance).toFixed(3).slice(0, -1)) : '0.00'),
  EarningOfPaying: state => (state.user.EarningOfPaying ? Number(parseFloat(state.user.EarningOfPaying).toFixed(3).slice(0, -1)) : '0.00'),
  StoreGoodsSwitch: state => state.user.StoreGoodsSwitch,
  Special: state => state.user.Special,
  UnreadCount: state => state.user.UnreadCount,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js